<template>
  <transition name="fade" :duration="100">
    <div v-show="show" class="exit-intent-container" @scroll.prevent.stop>
      <div class="popup" @click="show = false">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ExitIntent',
  data() {
    return {
      show: false,
    }
  },
  created() {
    document.addEventListener('mouseout', this.exitIntent)
  },
  beforeDestroy() {
    document.removeEventListener('mouseout', this.exitIntent)
  },
  methods: {
    exitIntent(e) {
      if (e.toElement === null && e.relatedTarget === null && !localStorage.getItem('exitintent_show')) {
        this.show = true
        //localStorage.setItem('exitintent_show', 'true'); // Set the flag in localStorage
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.exit-intent-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.popup {
  padding: 50px;
  background-color: white;
  width: 600px;
  max-width: 100vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>